import React, { Component, Fragment } from 'react';
import axios from 'axios';

import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

import withStyles from '@mui/styles/withStyles';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { TextField, InputAdornment } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';

import Loading from "./helper/Loading"
import { authContext } from "../context/AuthContext";
import styles from "./styles";
import PageHeader from "./helper/PageHeader";
import { withTranslation } from 'react-i18next';

import TextFieldValidator from './helper/TextFieldValidator';
import moment from 'moment';

class User extends Component {
    static contextType = authContext;

    constructor(props) {
        super(props);
      //  const {t} = props;
        
        this.token = sessionStorage.getItem('accessToken');
        let confirm = this.props.location.state ? this.props.location.state.afterRedeem : false;
        let query = this.props.location.search ? new URLSearchParams(this.props.location.search) : null;
        console.log("query: " + query);
        this.createUser = query? query.get('createUser') :null;
        console.log(this.createUser);
        this.state = {
            loading: true,

            isTrainee: sessionStorage.getItem('userTrack')==="S",
            confirm: confirm,
            states: [],
            workCounties: [],
            homeCounties: [],
            error: null,
            modalMode: '',
            username: this.props.match.params.id || '',
            firstName: '',
            lastName: '',
            middleName: '',
            suffix: '',
            birthdate: '',
            title: '',
            email: '',
            alternateEmail: '',
            password: '',
            passwordCheck: '',
            homephone: '',
            workphone: '',
            homeLocID: null,
            homeAddress: '',
            homeCity: '',
            homeState: '', //auto
            homeCounty: '',
            homeZipcode: '',
            workLocID: null,
            employerName: '',
            workAddress: '',
            workCity: '',
            workState: '',
            workCounty: '',
            workZipcode: '',
            ethnicity: '',
            age: '',
            gender: 0,
            jobTitle: '',
            companyEmployed: true,
            mailingAddressIsWorkLocation: false,

            isGatorLinkId: false,
            gatorLinkUsername: null,

            note: '',

            updateSuccess: null,
            usernameChecked: false,

            tookGIBMPTraining : '',
            holdPesticideLicense : '',
            holdFertilizerLicense: '',
            fertilizerLicense: '',
            pesticideLicense:'',
            updateChecker: null
        }
    }

    componentDidMount() {
        // on mount
        this.setStateOptions();

        this.refresh();

        let currDate = new Date()
        currDate = moment(currDate).format('YYYY-MM-DD')

        ValidatorForm.addValidationRule('checkPasswords', (value) => {
            //console.log(this.state)
            if (value !== this.state.password) {
                return false;
            }
            return true;
        });

        ValidatorForm.addValidationRule('checkBirthday', (value) => {
            if( value > currDate ){
                return false;
            }
            return true;
        });
    }

    componentWillUnmount() {
        // on unmount
        if (ValidatorForm.hasValidationRule('checkPasswords'))
            ValidatorForm.removeValidationRule('checkPasswords');

            if (ValidatorForm.hasValidationRule('checkBirthday'))
            ValidatorForm.removeValidationRule('checkBirthday');

        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state,callback)=>{
            return;
        };
    }


    setStateOptions = () => {
        axios('/api/stateCounty/states', {
            method: 'GET'
        }).then(res => {
            let states = [];
            res.data.states.map((u) =>
                states.push({ label: u, value: u })
            );
            console.log("SET STATE OPTIONS")
            this.setState({
                states,
            })
        }).catch(error => {
            this.setError(error)
        });
    }

    refresh = async () => {
        console.log(this.props.match.params.id)
        if (this.props.match.params.id !== undefined) {
            this.setState({ modalMode: 'Update' })

            try{
            const res = await axios.get('/api/user/' + this.props.match.params.id)
                const result = res.data
                console.log("role trainee: " +  this.context.roles && this.context.roles.isTrainee);
                // grab initial fields from res
                let data = {
                    isTrainee: this.context.roles && this.context.roles.isTrainee ? true : false,
                    username: result.user.username, //username will be the same as props.id
                    firstName: result.user.first_name,
                    title: result.user.title,
                    lastName: result.user.last_name,
                    middleName: result.user.middle_name,
                    suffix: result.user.suffix===null ? '' : result.user.suffix,
                    credit: result.user.credit,
                    email: result.user.email,
                    birthdate: result.birthdate,
                    alternateEmail: result.userExt.secondaryEMAIL,
                    trainingID: result.userExt.TRAINEEID,
                    pesticideLicense: result.userExt.PESTICIDELICENSENUMBER,
                    fertilizerLicense: result.userExt.FERTILIZERLICENSENUMBER,
                    tookGIBMPTraining: result.userExt.TOOKGIBMPTRAINING,
                    holdPesticideLicense: result.userExt.HOLDPESTICIDELICENSE,
                    holdFertilizerLicense: result.userExt.HOLDFERTILIZERLICENSE,
                    gender: result.userExt.GENDER,
                    homephone: result.userExt.HOMEPHONE,
                    workphone: result.userExt.WORKPHONE,
                    ethnicity: result.userExt.ETHNICITY,
                    age: result.userExt.AGE,
                    jobTitle: result.userExt.JOBTITLE,
                    companyEmployed: result.userExt.companyEmployed,
                    mailingAddressIsWorkLocation: result.userExt.mailingAddressIsWorkLocation,
                    homeLocID: result.userExt.homeLocationId,
                    workLocID: result.userExt.workLocationId,
                }
                //console.log("SETTING FORM DATA", data)

                console.log('this is homweloc data', result.homeLoc)

                // if the homLoc is defined, then get the address and city fields from that part of the res
                if (result.homeLoc) {
                    data = {
                        ...data,
                        homeAddress: result.homeLoc.STREET,
                        homeCity: result.homeLoc.CITY,
                        homeState: result.homeLoc.STATECODE,
                        homeCounty:  result.homeLoc.COUNTYCODE,
                        homeCounties: await this.getCounties(result.homeLoc.STATECODE),
                        homeZipcode: result.homeLoc.ZIPCODE
                    };
                    //console.log("SETTING FORM DATA AGAIN (homeLoc)", data)
                }

                // same as above but for workLoc
                if (result.workLoc) {
                    data = {
                        ...data,
                        employerName: result.workLoc.NAME,
                        workAddress: result.workLoc.STREET,
                        workCity: result.workLoc.CITY,
                        workState: result.workLoc.STATECODE ,
                        workCounty: result.workLoc.COUNTYCODE ,
                        workCounties: await this.getCounties(result.workLoc.STATECODE),
                        workZipcode: result.workLoc.ZIPCODE
                    };
                    //console.log("SETTING FORM DATA AGAIN (workLoc)", data)
                }


                // sets form state based on data
                this.setState(data)
                this.setState({
                    loading: false
                })
           
            } catch(error) {
                    this.setError(error)

            };
        } else {
            console.log(this.props.location.search)
            if (this.createUser) {
                this.setState({       
                    isGatorLinkId: true,
                    gatorLinkUsername: this.createUser,
                    username: this.createUser
                });
            }

            console.log("create")
            this.setState({ modalMode: 'Create', loading: false })
        }
    }

    hideError = () => {
        this.setState({error: ''})
    }

    setError = (error) => {
        console.log("ERROR", error);
        console.log("ERROR MESSAGE", error.message)
        //this.setState({ error: error.message })
    }

    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handleSelectChange =  async (event) => {
        if (event.target.name === 'homeState' && event.target.name !== null) {

            let selectedHomeState = event.target.value;
            let county = await this.getCounties(selectedHomeState)
       
            this.setState({
                homeCounties: county,
                homeCounty: ''
            })
           
        } else if (event.target.name === 'workState' && event.target.name !== null) {
            let selectedHomeState = event.target.value;
            let county = await this.getCounties(selectedHomeState)
          
            this.setState({
                workCounties: county,
                workCounty: ''
            })
           
        }
        console.log('name, val', event.target.name, event.target.value)
        this.setState({ [event.target.name]: event.target.value });
    }

    handleHomeStateChange = async (value) => {
        let selectedHomeState = value.value;
        let county = await this.getCounties(selectedHomeState)
        console.log('this selectedhome state', selectedHomeState)
        this.setState({
            homeCounties: county,
            homeCounty: '',
            homeState: selectedHomeState
        })

    }

    handleWorkStateChange = async (value) => {
        let selectedWorkState = value.value;
        let county = await this.getCounties(selectedWorkState)
       
        this.setState({
            workCounties: county,
            workCounty: '',
            workState: selectedWorkState
        })

    }

    handleCountyHomeChange = (value) => {
        this.setState({
            homeCounty: value.value,
        })
    }

    handleCountyWorkChange = (value) => {
        this.setState({
            workCounty: value.value,
        })
    }

    handleCheckChange = event => {
        // console.log("event:" + event.target.name + " value:" + event.target.checked);

        this.setState({
            [event.target.name]: event.target.checked
        });
    }

    handleOptionChange = event => {
        // console.log("event:" + event.target.name + "id:" + event.target.id + " checked:" + event.target.checked);
        if (event.target.value === 'useWork' || event.target.value === 'yes') {
            this.setState({ [event.target.name]: true });
        } else {
            this.setState({ [event.target.name]: false });
        }
    }

    handleGenderChange = event => {
         console.log("event:" + event.target.name + "id:" + event.target.id + " checked:" + event.target.checked);
        if (event.target.value === 'isMale') {
            this.setState({ [event.target.name]: 1 });
        } 
        if (event.target.value === 'isFemale') {
            this.setState({ [event.target.name]: 2 });
        } 
        if (event.target.value === 'isOther') {
            this.setState({ [event.target.name]: 0 });
        }
    }

    getCounties = async state => {
        if(state===null || state=== '') return []
        const res = await axios.get('/api/stateCounty/county/' + state)
        const counties =  res.data.map(county => ({ label: county.stateCountyName, value: county.stateCountyName }))
        return counties
    }

    onAdd = async (event) => {
        // console.log(formState);
        console.log("On add");
        if (this.state.username.match(/^[a-zA-Z0-9_-]*$/) === null){
            console.log('matched')
            this.setState({ 
                usernameChecked : false,
                error: this.state.username + " contains invalid characters. Only numbers, letters, - and _ are allowed"
            });
            return;
        }
        
        try {
            this.setState({loading: true})
            await axios('/api/user', {
                method: 'POST',
                data: JSON.stringify(this.state),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (this.state.isGatorLinkId) {
              //  await axios('/uflogin', {
             //       method: 'GET',
                //});
                this.props.history.replace('/login');
            }
            else {
                await this.context.login(this.state.username, this.state.password);

                let userTrack = sessionStorage.getItem('userTrack');

                if (userTrack === 'E')
                    this.props.history.push('/dashboard/employers/' + this.state.username);
                else if (userTrack === 'S')
                    this.props.history.push('/dashboard/trainingMain');
                 else if (userTrack === 'Z')
                    this.props.history.push('/zoomClass');
                else
                    this.props.history.push('/dashboard');
            }
        } catch(error) {
            this.setError(error)
            this.setState({loading: false})
        }
    }

    onUpdate = async (event) => {
        var url = "/api/user/" + this.props.match.params.id;
        //console.log(JSON.stringify({ ...this.state, username: this.props.match.params.id }))
        try {
            let response = await axios(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                data: JSON.stringify({ ...this.state, username: this.props.match.params.id })
            });
            console.log(response);
            if (response.status >= 400) {
                throw new Error(response.statusText);
            }
            await this.context.updateUser(this.props.match.params.id)

            // if this is a confirmation after a credit redemption for a trainng/test, redirect to dashboard
            console.log(this.state.confirm);
            if (this.state.confirm) {
                 this.props.history.push('/dashboard');
            } else {
                // DD A VISUAL INDICATOR OF AN UPDATE 
                this.setState({ updateSuccess: true })
                setTimeout(() => this.setState({ updateSuccess: null }), 5000 );
                this.refresh();
            }
        } catch (error) {
            this.setError(error)
            this.setState({ updateSuccess: false })        
        }
    }

    onResetPassword = (event) => {
        this.props.history.push({
            pathname: '/resetPassword/' + this.props.match.params.id
        });
    }

    onCheckUsername  = (event) => {
        if (this.state.username === undefined || this.state.username.length <1) {
            this.setState({ 
                error: "username cannot be empty",
                usernameChecked : false
            });
            return;
        }

        if (this.state.username.match(/^[a-zA-Z0-9_-]*$/) === null){
            console.log('matched')
            this.setState({ 
                usernameChecked : false,
                error: this.state.username + " contains invalid characters. Only numbers, letters, - and _ are allowed"
            });
            return;
        }

        axios('/api/user/exist/' + this.state.username, {
            method: 'GET'
        })
        .then(res => res.data)
        .then(result => {
            if (result.exist) {
                // username is already been used, set error message
                if (this.state.isGatorLinkId) {
                    this.setState({ 
                        usernameChecked : false,
                        error: this.state.username + " has already been used. If you have a GI-BMP login account with this username, please contact Customer Support to enable GatorLink login.  If this is not your account, pick a different GI-BMP username to create a new account."
                    });
                } else {
                    this.setState({ 
                        usernameChecked : false,
                        error: this.state.username + " has already been used. Please pick a different username."
                    });
                }
            }
            else 
                this.setState({ 
                    usernameChecked: true,
                    error: ''
                });
        }).catch(error => {
            this.setError(error);
        });
    }

     
    
    renderTrainee = (classes) => {
        
        
        const ethnicities = [
            {
                value: '',
                label: '',
            },
            {
                value: 'White',
                label: this.props.t('UserProfile.Caucasian'),
            },
            {
                value: 'Black or African American',
                label: this.props.t('UserProfile.Black'),
            },
            {
                value: 'Hispanic or Latino or Spanish Origin of any race',
                label: this.props.t('UserProfile.Hispanic'),
            },
            {
                value: 'Asian',
                label: this.props.t('UserProfile.Asian'),
            },
            {
                value: 'American Indian or Alaskan Native',
                label: this.props.t('UserProfile.NativeAmerican'),
            },
            {
                value: 'Native Hawaiian or Other Pacific Islander',
                label: this.props.t('UserProfile.PacificIslander'),
            },
            {
                value: 'Two or more races',
                label: this.props.t('UserProfile.MultipleRace'),
            },
        ];
        const ageRanges = [
            { 
                value:'',
                label: '',
            },
            {
                value: '17 or younger',
                label: this.props.t('UserProfile.17oryounger'),
            },
            {
                value: '18-25',
                label: '18-25',
            },
            {
                value: '26-35',
                label: '26-35',
            },
            {
                value: '36-45',
                label: '36-45',
            },
            {
                value: '46-60',
                label: '46-60',
            },
            {
                value: '61 or older',
                label: this.props.t('UserProfile.61OrOlder'),
            },
        ];



        const handleNeedTest = event => {
            if (event.target.value === 'Yes') {
                
               this.setState({tookGIBMPTraining: true})
            } else {
                this.setState({tookGIBMPTraining: false})
            }
        }

        const handleNeedTestPL = event => {
            if (event.target.value === 'Yes') {
                
               this.setState({holdPesticideLicense: true})
            } else {
                this.setState({holdPesticideLicense: false})
            }
        }

        const handleNeedTestFL = event => {
            if (event.target.value === 'Yes') {
                
               this.setState({holdFertilizerLicense: true})
            } else {
                this.setState({holdFertilizerLicense: false})
            }
        }

        return (
            <Fragment>
               
                
                <Grid container spacing={3}>

                        <Grid item xs={12} >
                            <FormLabel component="legend"  > {this.props.t('UserProfile.MailingAddress')} </FormLabel>
                            <RadioGroup row aria-label="address" name="address" onChange={this.handleOptionChange} >
                                <FormControlLabel
                                    id="useWork"
                                    value="useWork"
                                    checked={this.state.mailingAddressIsWorkLocation}
                                    control={<Radio color="primary" />}
                                    label= {this.props.t('UserProfile.Work')} 
                                    name="mailingAddressIsWorkLocation"
                                    componentsProps={{ tabIndex: "0" }}
                                />
                                <FormControlLabel
                                    id="useHome"
                                    value="useHome"
                                    checked={!this.state.mailingAddressIsWorkLocation}
                                    control={<Radio color="primary" />}
                                    label={this.props.t('UserProfile.Home')} 
                                    name="mailingAddressIsWorkLocation"
                                    componentsProps={{ tabIndex: "0" }}
                                />
                            </RadioGroup>
                        </Grid>



                        <Grid item xs={12}  sm={6} lg={4}>
                            <FormLabel component="legend"
                            >
                                Have you taken GI-BMP training before?  
                            </FormLabel>
                            <RadioGroup row aria-label="open" name="open" onChange={handleNeedTest}  >
                                <FormControlLabel
                                    id="isInPerson"
                                    value="Yes"
                                    checked={ this.state.tookGIBMPTraining===null? '' : this.state.tookGIBMPTraining }
                                    control={<Radio  color="primary" />}
                                    label="Yes"
                                    name="isGIBMPTrainee"
                                    componentsProps={{ tabIndex: "0" }}
                                />
                                <FormControlLabel
                                    id="isRemote"
                                    value="No"
                                    checked={ this.state.tookGIBMPTraining===null? '' : !this.state.tookGIBMPTraining }
                                    control={<Radio  color="primary" />}
                                    label="No"
                                    name="isGIBMPTrainee"
                                    componentsProps={{ tabIndex: "0" }}
                                />
                            </RadioGroup>
                                    
                                
                        </Grid>

                        {
                            this.state.tookGIBMPTraining === true
                            ?
                            <Grid>
                                <TextValidator
                                    id="trainingID"
                                    label={this.props.t('UserProfile.TrainingID')}
                                    type="text" className={[classes.textField].join(' ')}
                                    onChange={this.handleChange}
                                    value={this.state.trainingID || ""}
                                    name='trainingID'
                                    fullWidth
                                />
                            </Grid>
                            :
                            <></>
                        }


                    

                        <Grid item xs={12} sm={6} lg={4} >
                            <FormLabel 
                                component="legend"
                            > Do you have a pesticide license? 
                            </FormLabel>
                            <RadioGroup row aria-label="open" name="open" onChange={handleNeedTestPL}>
                                <FormControlLabel
                                    id="isInPerson"
                                    value="Yes"
                                    checked={ this.state.holdPesticideLicense===null ? '' : this.state.holdPesticideLicense }
                                    control={<Radio color="primary" />}
                                    label="Yes"
                                    name="isPesticideLicense"
                                />
                                <FormControlLabel
                                    id="isRemote"
                                    value="No"
                                    checked={ this.state.holdPesticideLicense===null ? '' : !this.state.holdPesticideLicense }
                                    control={<Radio color="primary"  />}
                                    label="No"
                                    name="isPesticideLicense"
                                />
                            </RadioGroup> 
                                    
                                
                        </Grid>
                        {
                            this.state.holdPesticideLicense === true
                            ?
                            <Grid>
                            <TextValidator
                                id="pesticideLicense"
                                label= {this.props.t('UserProfile.PesticideLicense')}
                                type="text" className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.pesticideLicense || ""}
                                name='pesticideLicense'
                                fullWidth
                            />
                            </Grid>
                            :
                            <></>
                        }

                    

                        <Grid item xs={12} sm={6} lg={4} >
                            <FormLabel 
                                component="legend"
                            >Do you have a fertilizer applicator license? 
                            </FormLabel>
                            <RadioGroup row aria-label="open" name="open" onChange={handleNeedTestFL} >
                                <FormControlLabel
                                    id="isInPerson"
                                    value="Yes"
                                    checked={ this.state.holdFertilizerLicense===null ? '' : this.state.holdFertilizerLicense }
                                    control={<Radio color="primary"  />}
                                    label="Yes"
                                    name="isFertilizerApplicator"
                                    componentsProps={{ tabIndex: "0" }}
                                />
                                <FormControlLabel
                                    id="isRemote"
                                    value="No"
                                    checked={ this.state.holdFertilizerLicense===null ? '' : !this.state.holdFertilizerLicense }
                                    control={<Radio color="primary" />}
                                    label="No"
                                    name="isFertilizerApplicator"
                                    componentsProps={{ tabIndex: "0" }}
                                />
                            </RadioGroup>     
                        </Grid>

                        {
                            this.state.holdFertilizerLicense === true
                            ?
                            <Grid>
                            <TextValidator
                                id="fertilizerLicense"
                                label= {'Fertilizer License #'}
                                type="text" className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.fertilizerLicense || ""}
                                name='fertilizerLicense'
                                fullWidth
                            />
                        </Grid>
                        :
                        <></>
                        }
                    
                    <Grid item xs={12}>
                        <TextValidator
                            id="homeAddress"
                            label={this.props.t('UserProfile.Address')} 
                            type="text"
                            className={[classes.textField].join(' ')}
                            onChange={this.handleChange}
                            value={this.state.homeAddress}
                            name='homeAddress'
                            validators={['required']}
                            errorMessages={['Address is required']}
                            fullWidth
                            required
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                        <TextValidator
                            id="homeCity"
                            label={this.props.t('UserProfile.City')} 
                            type="text"
                            className={[classes.textField].join(' ')}
                            onChange={this.handleChange}
                            value={this.state.homeCity}
                            name='homeCity'
                            validators={['required']}
                            errorMessages={['City is required']}
                            fullWidth
                            required
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>  
                        <TextFieldValidator
                                id="homeState"
                                name="homeState"
                                value={this.state.homeState}
                                states = {this.state.states}
                                classname = {[classes.textField].join(' ')}
                                handleSelectChange = {this.handleHomeStateChange}
                                validators={['required']}
                                errorMessages={['State is required']}
                                helperText = "State is required"
                                label={this.props.t('UserProfile.State')} 
                            />

                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
 
                        <TextFieldValidator
                                id="homeCounty"
                                name="homeCounty"
                                value={this.state.homeCounty}
                                states = {this.state.homeCounties}
                                classname = {[classes.textField].join(' ')}
                                handleSelectChange = {this.handleCountyHomeChange}
                                validators={['required']}
                                errorMessages={['County is required']}
                                helperText = "County is required"
                                label={this.props.t('UserProfile.County')} 
                            />
                     
                    </Grid>

                    <Grid item xs={12} sm={6} lg={3}>
                        <TextValidator
                            id="homeZipcode"
                            label= {this.props.t('UserProfile.Zipcode')} 
                            type="number"
                            className={[classes.textField].join(' ')}
                            onChange={this.handleChange}
                            value={this.state.homeZipcode}
                            name='homeZipcode'
                            validators={['required']}
                            errorMessages={['Zipcode is required']}
                            fullWidth
                            required
                        />
                    </Grid>
                </Grid>

                <div>
                    <Box pb={3} mt={4} mb={4} borderBottom={1} borderColor="#E0E0E0">
                        <h4 className="page-heading">{this.props.t('UserProfile.WorkInformation')} </h4>
                    </Box>
                </div>

                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} >
                        <TextValidator
                            id="jobTitle"
                            label={this.props.t('UserProfile.JobTitle')}
                            type="text" className={[classes.textField].join(' ')}
                            onChange={this.handleChange}
                            value={this.state.jobTitle}
                            name='jobTitle'
                            fullWidth
                        />
                    </Grid>

                    <Grid item xs={12}  sm={6} >
                        <FormLabel component="legend"> {this.props.t('UserProfile.OrgCheck')} </FormLabel>
                        <RadioGroup row aria-label="work" name="work" onChange={this.handleOptionChange} defaultValue="yes" >
                            <FormControlLabel
                                id="yes"
                                value="yes"
                                checked={this.state.companyEmployed}
                                control={<Radio color="primary" />}
                                label={this.props.t('UserProfile.Yes')}
                                name="companyEmployed"
                            />
                            <FormControlLabel
                                id="no"
                                value="no"
                                checked={!this.state.companyEmployed}
                                control={<Radio color="primary" />}
                                label={this.props.t('UserProfile.No')}
                                name="companyEmployed"
                            />
                        </RadioGroup>
                    </Grid>
                </Grid>
               
                {this.state.companyEmployed &&
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} >
                            <TextValidator
                                id="employerName"
                                label={this.props.t('UserProfile.EmployerName')}
                                type="text" className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.employerName}
                                name='employerName'
                                validators={['required']}
                                errorMessages={['employer name is required']}
                                fullWidth
                                required
                            />
                        </Grid>
                        

                        <Grid item xs={12} sm={6} >
                            <TextValidator
                                id="workAddress"
                                label= {this.props.t('UserProfile.WorkAddress')}
                                type="text"
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.workAddress}
                                name='workAddress'
                                validators={['required']}
                                errorMessages={['Address is required']}
                                fullWidth
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} lg={3}>
                            <TextValidator
                                id="workCity"
                                label= {this.props.t('UserProfile.City')}
                                type="text"
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.workCity}
                                name='workCity'
                                validators={['required']}
                                errorMessages={['City is required']}
                                fullWidth
                                required
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} lg={3}>
                            <TextFieldValidator
                                id="workState"
                                name="workState"
                                value={this.state.workState}
                                states = {this.state.states}
                                classname = {[classes.textField].join(' ')}
                                handleSelectChange = {this.handleWorkStateChange}
                                validators={['required']}
                                errorMessages={['State is required']}
                                helperText = "State is required"
                                label={this.props.t('UserProfile.State')} 
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} lg={3}>
                            <TextFieldValidator
                                id="workCounty"
                                name="workCounty"
                                value={this.state.workCounty}
                                states = {this.state.workCounties}
                                classname = {[classes.textField].join(' ')}
                                handleSelectChange = {this.handleCountyWorkChange}
                                validators={['required']}
                                errorMessages={['County is required']}
                                helperText = "County is required"
                                label={this.props.t('UserProfile.County')} 
                            />
                     
                        </Grid>
                       
                        <Grid item xs={12} sm={6} lg={3}>
                            <TextValidator
                                id="workZipcode"
                                label= {this.props.t('UserProfile.Zipcode')}
                                type="number"
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.workZipcode}
                                name='workZipcode'
                                validators={['required']}
                                errorMessages={['Zipcode is required']}
                                fullWidth
                                required
                            />
                        </Grid>
                    </Grid>
                }

                <div>
                    <Box pb={3} mt={4} mb={4} borderBottom={1} borderColor="#E0E0E0">
                        <h4 className="page-heading">{this.props.t('UserProfile.Demographics')}</h4>
                    </Box>
                </div>

                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <FormLabel component="legend">{this.props.t('UserProfile.Gender')}</FormLabel>
                        <RadioGroup row aria-label="genderLabel" name="gender" onChange={this.handleGenderChange}>
                            <FormControlLabel
                                id="isMale"
                                value="isMale"
                                checked={this.state.gender === 1 ? true : false}
                                control={<Radio color="primary" />}
                                label= {this.props.t('UserProfile.Male')}
                                name="gender"
                            />
                            <FormControlLabel
                                id="isFemale"
                                value="isFemale"
                                checked={this.state.gender ===2 ? true : false}
                                control={<Radio color="primary" />}
                                label= {this.props.t('UserProfile.Female')}
                                name="gender"
                            />
                            <FormControlLabel
                                id="isOther"
                                value="isOther"
                                checked={(this.state.gender === 0 || this.state.gender === null) ? true : false}
                                control={<Radio color="primary" />}
                                label= {this.props.t('UserProfile.Other')}
                                name="gender"
                            />
                        </RadioGroup>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="ethnicity"
                            name="ethnicity"
                            className={[classes.textField].join(' ')}
                            value={this.state.ethnicity ? this.state.ethnicity : ''}
                            onChange={this.handleSelectChange}
                            select
                            fullWidth
                            label= {this.props.t('UserProfile.Ethnicity')}
                        >
                            {ethnicities.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="age"
                            name="age"
                            className={[classes.textField].join(' ')}
                            value={this.state.age}
                            onChange={this.handleSelectChange}
                            select
                            fullWidth
                            label= {this.props.t('UserProfile.Age')}
                        >
                            {ageRanges.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                </Grid>
            </Fragment>
        );
    }

    renderPassword = (classes) => {
        if (this.state.modalMode === 'Create') {
            return (
                <Fragment>
                    <Grid item xs={12} sm={6}>
                        <TextValidator
                            id="password"
                            label= {this.props.t('UserProfile.Password')}
                            type="password"
                            className={[classes.textField].join(' ')}
                            onChange={this.handleChange}
                            value={this.state.password}
                            name='password'
                            validators={['required']}
                            errorMessages={['Password is required']}
                            fullWidth
                            required
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextValidator
                            id="passwordCheck"
                            label= {this.props.t('UserProfile.ConfirmPassword')}
                            type="password"
                            className={[classes.textField].join(' ')}
                            onChange={this.handleChange}
                            value={this.state.passwordCheck}
                            name='passwordCheck'
                            validators={['checkPasswords', 'required']}
                            errorMessages={['Password and Confirm Password must match', 'Confirm Password is required']}
                            fullWidth
                            required
                        />
                    </Grid>
                </Fragment>
            );
        } else {
            return (
                <Grid item xs={12}>
                    <Button variant="contained" color="primary" className={[].join(' ')} onClick={this.onResetPassword}> {this.props.t('UserProfile.ResetPassword')} </Button>
                </Grid>
            );
        }
    }

    handleInvalid(errors){
        // this focuses on the first component with a validation error
        const focusElem = document.getElementsByName(errors[0].props.name)
        if(focusElem.length === 1)
            focusElem[0].focus()
        
        // it seems like if it finds an autocomplete, there is a div and then an input with the same name. .focus does not seem to work on the div's
        else
            focusElem[1].focus()
            
        // console.log(errors)
        // console.log(errors[0].props.name)

    }

    render() {

        const { classes } = this.props;

        const titles = [
            {
                value: '1',
                label: this.props.t('UserProfile.Mr') ,
            },
            {
                value: '2',
                label: this.props.t('UserProfile.Ms'),
            },
            {
                value: '3',
                label: this.props.t('UserProfile.Mrs'),
            },
            {
                value: '4',
                label: this.props.t('UserProfile.Dr'),
            },
        ];

        const Popup = props => {
            return (
                <div>
                    <br/>
                    <Alert severity={props.severity} onClose={props.onClose}>{props.text}</Alert>
                </div>
            )
        }

        if(this.state.loading) return <Loading />
        return (
            <Fragment>
                {
                    this.state.modalMode === 'Create' 
                    ? 
                    console.log('here create')
                    : 
                    this.state.confirm 
                    ? 
                    <Popup severity="success" text="Please make sure this form is correct and complete. This is the official record of your training."/>  
                    : 
                    console.log('here update')
                }

                {this.state.updateSuccess === true && <Popup severity="success" text={this.props.t('UserProfile.UpdatedSuccessfully')} onClose={() => this.setState({ updateSuccess: null })} />    }
                {this.state.updateSuccess === false && <Popup severity="warning" text={this.props.t('UserProfile.ErrorUpdating')}  onClose={() => this.setState({ updateSuccess: null })} />}
                <ValidatorForm
                    noValidate
                    onError={this.handleInvalid} //called on a validation error, used to focus the first element
                    onSubmit={this.state.modalMode === "Create" ? this.onAdd : this.onUpdate}
                    /*autoComplete="off"*/
               >
                    <PageHeader
                        title={this.props.t('UserProfile.UserProfile')} 
                        cancel={this.props.history.goBack}
                        cancelDisabled = {this.state.confirm}
                        actionButtons={[{ 
                            label: this.state.modalMode === 'Create' ? this.props.t('UserProfile.Create') : this.state.confirm ? this.props.t('UserProfile.Confirm')  : this.props.t('UserProfile.Update'),
                            disabled: this.state.modalMode === 'Create' && !this.state.usernameChecked ? true : false
                        }] }
                        errorDetails={{
                            feedback: this.state.error,
                            dismiss: this.hideError
                        }}
                    /> 
                    {this.state.isTrainee === true &&
                        <Alert severity="info" >{this.props.t('UserProfile.TraineeInstruction')}</Alert>
                    }
                    {this.state.isTrainee !== true &&

                        <Alert severity="info" >{this.props.t('UserProfile.Instruction')}</Alert>
                    }
            
                    <br/>
                    <div>
                        <Grid container spacing={3}>
                            {this.state.modalMode === 'Create' &&
                                <Grid item xs={10} sm={4} >
                                    <TextValidator
                                        id="username"
                                        label= {this.props.t('UserProfile.Username')}
                                        type="text"
                                        style={{ minWidth: '10ch' }}
                                        className={[classes.textField].join(' ')}
                                        onChange={this.handleChange}
                                        value={this.state.username}
                                        name='username'
                                        InputProps={{
                                              endAdornment: (
                                                <InputAdornment position="end">
                                                {this.state.usernameChecked ? <CheckIcon /> : "" }
                                                </InputAdornment>
                                              )
                                        }}
                                        validators={['required', 'matchRegexp:^[a-zA-Z0-9_-]*$']}
                                        errorMessages={['Username is required', 'only letters, numbers, - and _ are allowed']}
                                        fullWidth
                                        required
                                    />
                                </Grid>
                            }

                            {this.state.modalMode === 'Create' &&
                                <Grid item xs={2}>
                                    <Box display="flex" mt={2.5}>
                                        <Button variant="outlined"  onClick={this.onCheckUsername} size="small" color="primary" className={[].join(' ')} > {this.props.t('UserProfile.Check')} </Button>
                                    </Box>
                                </Grid>
                            }

                            {this.state.modalMode === 'Update' &&
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        id="username"
                                        label= {this.props.t('UserProfile.Username')}
                                        type="text"
                                        className={[classes.textField].join(' ')}
                                        value={this.state.username}
                                        name='username'
                                        fullWidth
                                        disabled
                                    />
                                </Grid>
                            }

                            <Grid item xs={12} sm={6}>
                                <TextValidator
                                    id="date"
                                    label= {this.props.t('UserProfile.Birthday')}
                                    type="date"
                                    name='birthdate'
                                    value={this.state.birthdate}
                                    className={[classes.textField].join(' ')}
                                    onChange={this.handleChange}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    validators={['checkBirthday', 'required']}
                                    errorMessages={['Birthday cant be a future day', 'Birthday is required']}
                                    fullWidth
                                    required
                                />
                            </Grid>

                            {this.state.modalMode !== 'Create' ? this.renderPassword(classes) : null}
                            <Grid item xs={12} sm={12}>
                            {this.state.modalMode === 'Update'  &&
                            <Alert severity="info" >To change your name, please contact GI-BMP office at (352) 273-4517 or gi.bmp@ifas.ufl.edu</Alert>
                            }
                            </Grid>
                            <Grid item xs={12} sm={1}>
                                <TextField
                                    id="title"
                                    name="title"
                                    style={{ minWidth: '5ch' }}
                                    className={[classes.textField].join(' ')}
                                    value={this.state.title ? this.state.title : ''}
                                    onChange={this.handleSelectChange}
                                    select
                                    fullWidth
                                    label= {this.props.t('UserProfile.Title')}
                                >
                                    {titles.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            
                            <Grid item xs={12} sm={3}>
                                <TextValidator id="firstName"
                                    label= {this.props.t('UserProfile.FirstName')}
                                    type="text"
                                    className={[classes.textField].join(' ')}
                                    onChange={this.handleChange}
                                    value={this.state.firstName}
                                    name='firstName'
                                    InputProps={{
                                        readOnly: this.state.modalMode === 'Create' ? false : true
                                    }}
                                    validators={['required']}
                                    errorMessages={['First name is required']}
                                    fullWidth
                                    required
                                />
                            </Grid>
                        
                            <Grid item xs={12} sm={2}>
                                <TextValidator id="middleName"
                                    label= {this.props.t('UserProfile.MiddleName')}
                                    type="text"
                                    className={[classes.textField].join(' ')}
                                    onChange={this.handleChange}
                                    value={this.state.middleName}
                                    name='middleName'
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={12} sm={3}>
                                <TextValidator id="lastName"
                                    label= {this.props.t('UserProfile.LastName')}
                                    type="text"
                                    className={[classes.textField].join(' ')}
                                    onChange={this.handleChange}
                                    value={this.state.lastName}
                                    name='lastName'
                                    InputProps={{
                                        readOnly: this.state.modalMode === 'Create' ? false : true
                                    }}
                                    validators={['required']}
                                    errorMessages={['Last name is required']}
                                    fullWidth
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextValidator id="suffix"
                                        label= {this.props.t('UserProfile.Suffix')}
                                        type="text"
                                        className={[classes.textField].join(' ')}
                                        onChange={this.handleChange}
                                        value={this.state.suffix}
                                        name='suffix'
                                        fullWidth
                                    />
                            </Grid>

                            {this.state.modalMode === 'Create' ? this.renderPassword(classes) : <span></span>}

                            <Grid item xs={12} sm={6} lg={3}>
                                <TextValidator
                                    id="email"
                                    label= {this.props.t('UserProfile.Email')}
                                    type="email"
                                    className={[classes.textField].join(' ')}
                                    placeholder='example@domain.com'
                                    onChange={this.handleChange}
                                    value={this.state.email}
                                    name='email'
                                    validators={['required', 'isEmail']}
                                    errorMessages={['Email is required', 'Please enter a valid email address']}
                                    fullWidth
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} lg={3}>
                                <TextValidator
                                    id="alternateEmail"
                                    label= {this.props.t('UserProfile.AlternateEmail')}
                                    type="email"
                                    className={[classes.textField].join(' ')}
                                    placeholder='example@domain.com'
                                    onChange={this.handleChange}
                                    value={this.state.alternateEmail}
                                    name='alternateEmail'
                                    validators={['isEmail']}
                                    errorMessages={['Please enter a valid email address']}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} lg={3}>
                                <TextValidator
                                    id="workphone"
                                    label= {this.props.t('UserProfile.WorkPhone')}
                                    type="tel"
                                    className={[classes.textField].join(' ')}
                                    placeholder='987-654-3210 x1234'
                                    onChange={this.handleChange}
                                    value={this.state.workphone}
                                    name='workphone'
                                    validators={['required', 'matchRegexp:^(\\+\\d{1,3}\\s?)?((\\(\\d{3}\\)\\s?)|(\\d{3})(\\s|-?))(\\d{3}(\\s|-?))(\\d{4})(\\s?(([E|e]xt[:|.|]?)|x|X)(\\s?\\d+))?$']}
                                    errorMessages={['Phone is required', 'Only "(", ")", "-", "x", and numbers are allowed. Must be at least 10 digits']}
                                    fullWidth
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} lg={3}>
                                <TextValidator
                                    id="homePhone"
                                    label= {this.props.t('UserProfile.HomePhone')}
                                    type="tel"
                                    className={[classes.textField].join(' ')}
                                    placeholder='987-654-3210 x1234'
                                    onChange={this.handleChange}
                                    value={this.state.homephone}
                                    name='homephone'
                                    validators={['matchRegexp:^(\\+\\d{1,3}\\s?)?((\\(\\d{3}\\)\\s?)|(\\d{3})(\\s|-?))(\\d{3}(\\s|-?))(\\d{4})(\\s?(([E|e]xt[:|.|]?)|x|X)(\\s?\\d+))?$']}
                                    errorMessages={['Only "(", ")", "-", "x", and numbers are allowed. Must be at least 10 digits']}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>

                        {this.state.isTrainee === true &&
                            this.renderTrainee(classes)
                        }

                    </div>
                    {this.state.updateSuccess === true && <Popup severity="success" text={this.props.t('UserProfile.UpdatedSuccessfully')} onClose={() => this.setState({ updateSuccess: null })} />    }
                    {this.state.updateSuccess === false && <Popup severity="warning" text={this.props.t('UserProfile.ErrorUpdating')}  onClose={() => this.setState({ updateSuccess: null })} />}
                    <PageHeader
                        title="" 
                        cancel={this.props.history.goBack}
                        cancelDisabled = {this.state.confirm}
                        actionButtons={[{ 
                            label: this.state.modalMode === 'Create' ? this.props.t('UserProfile.Create') : this.state.confirm ? this.props.t('UserProfile.Confirm')  : this.props.t('UserProfile.Update'),
                            disabled: this.state.modalMode === 'Create' && !this.state.usernameChecked ? true : false
                        }] }
                        errorDetails={{
                            feedback: this.state.error,
                            dismiss: this.hideError
                        }}
                    /> 
                    
                </ValidatorForm >
            </Fragment>

        );
    }
}

// export default User;
export default withStyles(styles, { withTheme: true })(withTranslation()(User));